<!-- <sm-title-bar pageTitle="{{ 'service_timings.home_title' | translate }}" [backWithParams]="true" *ngIf="serviceType == '0'"> </sm-title-bar>
<sm-title-bar pageTitle="{{ 'service_timings.shop_title' | translate }}" [backWithParams]="true" *ngIf="serviceType == '1'"> </sm-title-bar> -->
<sm-title-bar pageTitle="{{ 'service_timings.home_title' | translate }}" [backWithParams]="true" *ngIf="serviceType == '0'"> </sm-title-bar>
<sm-title-bar pageTitle="{{ 'service_timings.shop_title' | translate }}" [backWithParams]="true" *ngIf="serviceType == '1'"> </sm-title-bar>
<sm-title-bar pageTitle="Virtual Service Timings" [backWithParams]="true" *ngIf="serviceType == '2'"> </sm-title-bar>

<!-- <mat-card *ngIf="!loader">
<mat-card-header class="justify-content-between align-items-center mb-3"></mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="finalServiceTimings" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [itemsPerPage]="10">
      </sm-data-table>
    </div>
  </mat-card> -->
  
  <!-- <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item *ngIf="rowvalue.status == 0" (click)="openAddTime(rowvalue)">
      <mat-icon class="material-icons-outlined">add</mat-icon>
      <span>{{ 'service_timings.opt_add_time' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1 && rowvalue.toShowType =='parent'" (click)="openAddTime(rowvalue)">
      <mat-icon class="material-icons-outlined">link</mat-icon>
      <span>{{ 'service_timings.opt_add_more' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1" (click)="removeTime(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>{{ 'service_timings.opt_remove' | translate }}</span>
    </button>
  </ng-template> -->

  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->


  <section class="nw_service_th" *ngIf="!loader">
    <!-- <div class="service_se">
        <div class="heading_sert">
            <h3>Service hours</h3>
        </div>
       
    </div> -->

    <!-- <div class="service_create_sd">
    <div class="row">
        <div class="col-sm-9">
           <div class="serv_heading">
            <h3>{{serviceType == '0' ? 'Home Service Timings' : 'Shop Service Timings'}} of {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>

        </div>
      </div>
      <div class="col-sm-3">
       
      </div>
    </div>
    </div> -->




    <div class="schedule-container" *ngIf="groupedServiceTimings && toShowTimings">
   <div class="header_services">
    <div class="day_sp">
      <p class="td_header">Day</p>
    </div>
    <div class="day_sp session_otp">
      <p class="td_header"> Session</p>
    </div>
    <div class="day_sp session_otp">
      <p class="td_header"> Start Time</p>
    </div>
    <div class="day_sp session_ppt">
      <p class="td_header">Stop Time</p>
    </div>
    <div class="day_sp session_ppt" *ngIf="serviceType == '2'">
      <p class="td_header">Meeting Info</p>
    </div>
    <div class="option_mn">

    </div>
   </div>

<div *ngFor="let item of groupedServiceTimings; let i = index">
  <div class="body_services" *ngIf="item.timelist.length > 1" >
    <div class="or_nxt" *ngFor="let element of item.timelist;let j= index" [ngClass]="{'repectv': j > 0}">
    <div class="day_sp">
      <p class="fun_bt days_t">{{element.toShowType == 'parent' ? element.dayName : ''}}</p>
    </div>
    <div class="day_sp">
      <p>{{j+1}}</p>
    </div>
    <div class="day_sp">
      <p>{{element.openTime}}</p>
    </div>
    <div class="day_sp">
      <p>{{element.closeTime}}</p>
    </div>
    <div class="day_sp" *ngIf="serviceType == '2'">
      <div *ngIf="element.meeting_details">
        <mat-icon style="color: green;" *ngIf="element.meeting_details[0].meeting_details && element.meeting_details[0].meeting_details != '' && element.meeting_details[0].meeting_details != 'null'">task_alt</mat-icon>

      </div>
    </div>
    <div class="option_mn">
      <button mat-icon-button [matMenuTriggerFor]="homeMenu1" *ngIf="isOwner || serviceType == '2'">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #homeMenu1="matMenu">
      <button mat-menu-item *ngIf="element.status == 0 && isOwner" (click)="openAddTime(element)" >
        <mat-icon class="material-icons-outlined">add</mat-icon>
        <span>{{ 'service_timings.opt_add_time' | translate }}</span>
      </button>
      <button mat-menu-item (click)="openAddTime(element)" *ngIf="element.status == 1 && element.toShowType == 'parent' && isOwner"> <mat-icon class="material-icons-outlined" >add</mat-icon> Add more</button>
      <button mat-menu-item (click)="removeTime(element)" *ngIf="element.status == 1 && isOwner"> <mat-icon class="material-icons-outlined" >delete</mat-icon>Delete</button>
      <button mat-menu-item *ngIf="element.status == 1 && serviceType == '2'" (click)="openAddEditMeetingDetails(element)"> <mat-icon class="material-icons-outlined" >video_chat</mat-icon>Meeting info</button>
  </mat-menu>
    </div>
  </div>


   </div>
  <div class="body_services" *ngIf="item.timelist.length == 1">
    <div class="or_nxt" *ngFor="let element of item.timelist; let j= index">
      <div class="day_sp">
        <p class="fun_bt days_t">{{element.toShowType == 'parent' ? element.dayName : ''}}</p>
      </div>
      <div class="day_sp">
        <p>{{j+1}}</p>
      </div>
      <div class="day_sp">
        <p>{{element.openTime}}</p>
      </div>
      <div class="day_sp">
        <p>{{element.closeTime}}</p>
      </div>
      <div class="day_sp" *ngIf="serviceType == '2'">
        <div *ngIf="element.meeting_details">
          <mat-icon style="color: green;" *ngIf="element.meeting_details[0].meeting_details && element.meeting_details[0].meeting_details != '' && element.meeting_details[0].meeting_details != 'null'">task_alt</mat-icon>

        </div>
      </div>
    <div class="option_mn">
      <button mat-icon-button [matMenuTriggerFor]="homeMenu" *ngIf="isOwner || serviceType == '2'">
        <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #homeMenu="matMenu">
      <button mat-menu-item *ngIf="element.status == 0 && isOwner" (click)="openAddTime(element)">
        <mat-icon class="material-icons-outlined">add</mat-icon>
        <span>{{ 'service_timings.opt_add_time' | translate }}</span>
      </button>
      <button mat-menu-item (click)="openAddTime(element)" *ngIf="element.status == 1 && element.toShowType == 'parent' && isOwner"> <mat-icon class="material-icons-outlined" >add</mat-icon> Add more</button>
      <button mat-menu-item (click)="removeTime(element)" *ngIf="element.status == 1 && isOwner"> <mat-icon class="material-icons-outlined" >delete</mat-icon>Delete</button>
      <button mat-menu-item [disabled]="element.status == 0" *ngIf="(element.status == 1 && serviceType == '2') || !isOwner" (click)="openAddEditMeetingDetails(element)"> <mat-icon class="material-icons-outlined" >video_chat</mat-icon>Meeting info</button>
  </mat-menu>
    </div>
  </div>


   </div>
</div>









       <!-- new section added -->
   <div class="set_unbilty" *ngIf="isOwner">
    <mat-card>
    <div class="unb_heading">
      <h3>Set unavailability</h3>
      <p>Manage your shop/service unavailability based on selected dates. Customers wouldn't be able to book appointments on those days.</p>
    </div>
    <div class="set_yyt_btn">
      <button mat-flat-button (click)="configureUnavailability()">Configure dates</button>
    </div>
    </mat-card>
  </div>
  <!-- new section added -->
</div> 
      
      
    <!-- Placeholder design html start -->
    <div class="placeholder_started" *ngIf="!groupedServiceTimings || !toShowTimings">
      <div class="row">
        
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/timeing-added.png">
               </div>
               <mat-card-title>No timings added</mat-card-title>
               <mat-card-content>You haven't added any service hours  for your {{this.serviceType == '0' ? 'home' :(this.serviceType == '1' ? 'shop' : 'virtual')}} service offerings. Add them to get bookings and business.
              </mat-card-content>
               <div class="create_btnyh">
                  <button mat-flat-button color="primary" (click)="changeTimingsViewStatus()" *ngIf="isOwner">
                      <mat-icon>add</mat-icon> 
                      Add {{this.serviceType == '0' ? 'home' :(this.serviceType == '1' ? 'shop' : 'virtual')}} timings
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/service-hours-3.png">
               </div>
               <mat-card-title>How to add service hours?</mat-card-title>
               <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on adding service hours against a business. You can check this video as well.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
               </div>
               <mat-card-title>Having any issue?</mat-card-title>
               <mat-card-content>For any difficulties in adding service hours or in edit after adding them, contact our support team.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="opencontact()">
                     <mat-icon>support_agent</mat-icon>
                     Contact support 
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
      </div>
  
    </div>
    <!-- Placeholder design html start -->

</section>



